import React, { Component } from 'react';
import { Card, CardBody, CardHeader, CardText, CardSubtitle } from 'reactstrap';

class Documentation extends Component {
  render() {
    return (
      <div
        style={{
          width: '90%',
          margin: 'auto',
          paddingTop: '20px',
          paddingBottom: '20px',
        }}
      >
        <Card>
          <CardHeader>Authentication</CardHeader>
          <CardBody>
            <CardSubtitle>
              The authentication returns the token which is used in the http
              header Authorization field for each request
            </CardSubtitle>
            <CardText>
              <code>
                &#123;<br />&nbsp;&nbsp;&nbsp;&nbsp;"username" :
                "&lt;usename&gt;",<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"password" : "&lt;password&gt;"<br />
                &#125;
                <br />
              </code>
              &lt;usename&gt; : the username of the client<br />{' '}
              &lt;password&gt; : The password for the user to login
              <br />URL: <code>/api/authenticate</code>
            </CardText>
          </CardBody>
        </Card>
        <br />
        <Card>
          <CardHeader>Top Up Request</CardHeader>
          <CardBody>
            <CardSubtitle>
              This API is used to send the request to top up the customer
              account. The API is the same for all network but the operator name
              changes. For example, if sending request to Orange Network, the
              operator will be "orange"
            </CardSubtitle>
            <CardText>
              <code>
                &#123;<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"msisdn" : "&lt;MSISDN&gt;",<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"currency" : "&lt;Currency&gt;",<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"providerCode": "&lt;Provider Code&gt;",<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"amount": &lt;Amount&gt;,<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"language": "&lt;Language&gt;",<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"operator": "&lt;Operator&gt;"<br />
                &#125;<br />
              </code>
              "&lt;MSISDN&gt;" : The MSISDN of the subscriber<br />{' '}
              "&lt;Currency&gt;" : The currency to do the transaction. The
              supported currency are USD and CDF<br /> "&lt;Provider Code&gt;" :
              Where applicable the Provider Code is given<br /> &lt;Amount&gt; :
              The amount to transfer to the subscriber<br /> "&lt;Language&gt;"
              : The language to send notification. The supported languages are
              FR and EN<br /> "&lt;Operator&gt;" : The operator which handle the
              request. The current supported operators are: airtel, orange and
              vodacash<br />
              URL: <code>/api/topup</code>
            </CardText>
          </CardBody>
        </Card>
        <br />
        <Card>
          <CardHeader>Mobile Money Top Up</CardHeader>
          <CardBody>
            <CardSubtitle>
              This API is used to transfer mobile money to a subscriber
            </CardSubtitle>
            <CardText>
              <code>
                &#123;<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"msisdn" : "&lt;MSISDN&gt;",<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"currency" : "&lt;Currency&gt;",<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"providerCode": "&lt;Provider Code&gt;",<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"amount": &lt;Amount&gt;,<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"language": "&lt;Language&gt;",<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"operator": "&lt;Operator&gt;"<br />
                &#125;<br />
              </code>
              "&lt;MSISDN&gt;" : The MSISDN of the subscriber<br />{' '}
              "&lt;Currency&gt;" : The currency to do the transaction. The
              supported currency are USD and CDF<br /> "&lt;Provider Code&gt;" :
              Where applicable the Provider Code is given<br /> &lt;Amount&gt; :
              The amount to transfer to the subscriber<br /> "&lt;Language&gt;"
              : The language to send notification. The supported languages are
              FR and EN<br /> "&lt;Operator&gt;" : The operator which handle the
              request. The current supported operators are: airtel, orange and
              vodacash<br />
              URL: <code>/api/mobilemoney</code>
            </CardText>
          </CardBody>
        </Card>
        <br />
        <Card>
          <CardHeader>Check Balance</CardHeader>
          <CardBody>
            <CardSubtitle>
              This API is used to query the current balance/credit
            </CardSubtitle>
            <CardText>
              <code>
                &#123;<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"msisdn" : "&lt;MSISDN&gt;",<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"currency" : "&lt;Currency&gt;",<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"amount": &lt;Amount&gt;,<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"language": "&lt;Language&gt;",<br />
                &nbsp;&nbsp;&nbsp;&nbsp;"operator": "&lt;Operator&gt;"<br />
                &#125;<br />
              </code>
              "&lt;MSISDN&gt;" : The MSISDN of the subscriber<br />{' '}
              "&lt;Currency&gt;" : The currency to do the transaction. The
              supported currency are USD and CDF<br /> "&lt;Provider Code&gt;" :
              Where applicable the Provider Code is given<br /> &lt;Amount&gt; :
              The amount to transfer to the subscriber<br /> "&lt;Language&gt;"
              : The language to send notification. The supported languages are
              FR and EN<br /> "&lt;Operator&gt;" : The operator which handle the
              request. The current supported operators are: airtel, orange and
              vodacash<br />
              URL: <code>/api/mobilemoney</code>
            </CardText>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default Documentation;



// WEBPACK FOOTER //
// ./src/views/Docx/Documentation.js